import { IconDefinition } from '@fortawesome/angular-fontawesome';
import { faBox, faFilter, faListCheck, faUser, faUserGroup } from '@fortawesome/free-solid-svg-icons';
import { faHouse } from '@fortawesome/free-regular-svg-icons';

// LISTA ICONE VOCI SIDENAV
// Aggiungere qua sotto l'icona relativa alla voce del menu laterale
const ICONS: Record<string, IconDefinition> = {
  faHouse, // Home
  faUserGroup, // Customers
  faListCheck, // Task
  faFilter,
  faUser, // Profile
  faBox, //prodotti
};

export function resolveFaIcon(key?: string): IconDefinition | null {
  if (!key) return null;
  return ICONS[key] ?? null;
}

// Versione alternativa con fallback
// const FALLBACK_ICON: IconDefinition = faCircleQuestion;

// export function resolveFaIcon(key?: string): IconDefinition {
//   if (!key) return FALLBACK_ICON;
//   return ICONS[key] ?? FALLBACK_ICON;
// }
